const normalize = (value) =>
  String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();

export function formatVenuePrice(venue) {
  if (!venue || !Number.isFinite(venue.priceLow) || !Number.isFinite(venue.priceHigh)) {
    return '';
  }

  const low = `$${Math.round(venue.priceLow).toLocaleString()}`;
  const high = `$${Math.round(venue.priceHigh).toLocaleString()}`;
  const range = venue.priceLow === venue.priceHigh ? low : `${low}–${high}`;
  const unit = venue.priceBasis === 'per_person' ? 'per person' : 'per event';

  return `${range} ${unit}`;
}

export function filterDenverVenues(
  venues,
  {
    query = '',
    category = 'all',
    area = 'all',
    headcount = 0,
    outdoorOnly = false,
  } = {}
) {
  const needle = normalize(query);

  return venues.filter((venue) => {
    if (category !== 'all' && venue.category !== category) return false;
    if (area !== 'all' && venue.area !== area) return false;
    if (outdoorOnly && !venue.outdoor) return false;
    if (headcount > 0 && venue.capacity < headcount) return false;

    if (!needle) return true;

    return normalize(
      [venue.name, venue.category, venue.area, venue.address, venue.catering].join(' ')
    ).includes(needle);
  });
}

export function venueEstimateLine(venue, headcount) {
  if (!venue) return null;

  const units = venue.priceBasis === 'per_person' ? Math.max(0, headcount) : 1;
  const low = venue.priceLow * units;
  const high = venue.priceHigh * units;

  return {
    kind: 'venue',
    venueId: venue.id,
    label: venue.name,
    detail:
      venue.isOwnSpace
        ? `${formatVenuePrice(venue)} · no separate venue rental`
        : venue.priceBasis === 'per_person'
        ? `${formatVenuePrice(venue)} × ${headcount} ${headcount === 1 ? 'person' : 'people'}`
        : `${formatVenuePrice(venue)} · up to ${venue.capacity.toLocaleString()} people`,
    basis: venue.priceBasis,
    low,
    high,
    confidence: venue.priceConfidence,
    confidenceLabel: venue.priceLabel,
    reviewedOn: venue.reviewedOn,
    includesFood: Boolean(venue.includesFood),
  };
}
